import Typography from '@toasttab/shared/src/components/atoms/Typography/Typography'
import HeroHeading from '@toasttab/shared/src/components/molecules/HeroHeading/HeroHeading'
import Column from '@toasttab/shared/src/components/organisms/MDS/Hero/Column'
import { ContentfulImageAPI } from '@toasttab/shared/src/utils/contentfulUtils'
import classNames from 'classnames'
import { graphql } from 'gatsby'
import React from 'react'
import ToastSupport from '@toasttab/shared/src/assets/svg/icon-toast-support.svg'
import ArrowForward from '@toasttab/shared/src/assets/svg/arrows-and-sharing/arrow-forward-dark-gray.svg'
import { marked } from 'marked'

export interface HeroProps {
  contentful_id?: string
  headline: string
  image?: any
  uniqueId: string
  testId: string
  classes?: string
}

const Hero = ({ contentful_id, headline, image, uniqueId, testId, classes }: HeroProps) => {
  const heroClasses = classNames(classes, {
    'pb-10 md:pb-8': !classes
  })
  const gridClasses = classNames({
    'ds-grid ds-container place-items-center': true,
    'text-center': true
  })
  const columnClass = classNames({
    'w-100 col-span-12 p-relative': true
  })

  const components: any = []
  components.push({
    typeHandle: 'heading',
    sectionHeading: headline
  })
  const query = ContentfulImageAPI.transformImageWebp()
  let imageUrl = image.desktop?.file.url + query
  if (!imageUrl.includes('http')) {
    imageUrl = `https:${imageUrl}`
  }
  const bgImage = [{ url: imageUrl }]
  const loginUrl = `https://central.toasttab.com/CommunitiesLogin?startURL=%2Fs%2F%3Ft%3D1724269994487`

  return (
    <section className={heroClasses} id={uniqueId}>
      <div className="bg-[#252525] text-white -mt-4 flex items-center justify-between p-4">
        <div className="flex items-center">
          <img src={ToastSupport} alt="Support Icon" className="w-8 h-8 mr-3" />
          <span>Access your support history and track case updates.</span>
        </div>
        <div>
          <a href={loginUrl} className="text-white hover:underline flex items-center">
            Log in to view your support cases
            <img src={ArrowForward} alt="" className="ml-1 w-5 h-5" />
          </a>
        </div>
      </div>
      <div
        className="relative bg-cover bg-center max-h-[400px] h-[400px] rounded-b-[50px]"
        style={{ backgroundImage: `url('${bgImage[0].url}')` }}
      >
        <div className="absolute inset-0 flex items-center justify-center bg-opacity-30">
          <div className="absolute top-0 flex justify-center w-full pt-16">
            <img src={ToastSupport} alt="more" className={``} />
          </div>
          <div className="text-center">
            <h1
              className="text-white text-5xl leading-none sm:text-5xl md:text-6xl font-bold"
              dangerouslySetInnerHTML={{ __html: marked.parseInline(headline) }}
            ></h1>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Hero
